module.exports = __webpack_public_path__ + "img/grand-palm-restaurant-2.b8466d58.jpg";